import React, { useState } from 'react';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import { mdiPackageVariant, mdiReceiptTextOutline } from '@mdi/js';
import { ConteudoPlanoAtual } from '../plano/ConteudoPlanoAtual';
import { ConteudoFaturas } from '../fatura/ConteudoFaturas';

type SubSecao = 'plano' | 'faturas';

const SecaoContaPagamentos = () => {
    const [subSecao, setSubSecao] = useState<SubSecao>('plano');

    return (
        <div>
            <HBox gap="8px" style={{ marginBottom: '16px' }}>
                <Botao
                    variant={subSecao === 'plano' ? 'primary' : 'outline-secondary'}
                    icon={mdiPackageVariant}
                    onClick={() => setSubSecao('plano')}
                >
                    Plano Atual
                </Botao>
                <Botao
                    variant={subSecao === 'faturas' ? 'primary' : 'outline-secondary'}
                    icon={mdiReceiptTextOutline}
                    onClick={() => setSubSecao('faturas')}
                >
                    Faturas
                </Botao>
            </HBox>

            {subSecao === 'plano' && <ConteudoPlanoAtual compact />}
            {subSecao === 'faturas' && <ConteudoFaturas compact />}
        </div>
    );
};

export default SecaoContaPagamentos;
